module.exports = __webpack_public_path__ + "static/media/reports.49e4b518.svg";